import { asyncTypes } from 'store/_helpers';

const TYPES = {
  ...asyncTypes('GET_CREW_RANK'),
  ...asyncTypes('UPDATE_CREW_RANK'),
  ...asyncTypes('REORDER_CREW_RANK'),
  ...asyncTypes('CREATE_CREW_RANK'),
  ...asyncTypes('DELETE_CREW_RANK')
};

export default TYPES;
